import styled from 'styled-components';
import { ColorAddiFontStrong, ColorAddiCompFourLighten2 } from '@addi/foundation/dist/web/colors';
import { Caption } from '../../typographies';
export const InputMessage = styled(Caption) `
    margin: 8px 0;
    color: ${({ isInvalid }) => isInvalid ? ColorAddiCompFourLighten2 : ColorAddiFontStrong};
`;
//# sourceMappingURL=InputMessage.Styled.js.map